const priceVolumeData = {
  quantity: {
    title: 'Quantity',
    overview: 'If you pick Quality, you will start with less cash on hand but a higher amount of money spent on product development and a larger amount of money able to take out in loans. Choosing quantity, you will start with plenty of cash but not a very well developed product. Undecided will result in a wishy-washy state where you spend some money on R&D, but not too much.',
    pros: [
      'You can pick and choose future upgrades as you wish, creating a highly customized product.',
      'You start with more available money for producing additional units, as well as a cheaper per unit manufacturing cost.',
      'You’ll have plenty of units available to start selling.',
      'In general, with more money available at the start, you are free to spend more on advertising, market research, plant capacity, etc.',
    ],
    cons: [
      'The starting consumer demand for your product will be lower, considering your lack of features that competitors provide.',
      'The price you can charge on your product is limited, considering the features and consumer perception of your product. Your margins per sale are smaller.',
      'Your intellectual property is less valuable, and your company is seen as less prestigious.',
      'Your competition has significantly better products.',
    ],
  },
  standard: {
    title: 'Standard',
    overview: 'This strategy is for companies that want to take practical, pragmatic moves in developing their product. However, standard priced products are difficult to initially market as they do not offer any special features compared to competitors.',
    pros: [
      'You have flexibility to change your product, but a good starting point.',
      'You don’t have the pressure to always have the best product and your customers don’t expect you to.',
      'As you haven’t deeply invested in anything, you have some money to spend as you are starting out.',
    ],
    cons: [
      'The starting consumer demand for your product will be lower, considering your lack of features that competitors provide.',
      'The price you can charge on your product is limited, considering the features and consumer perception of your product. Your margins per sale are smaller.',
      'Your company is seen as mediocre, not a ground breaker.',
      'Your competition has better products, at a higher cost. Some of your competition has inferior products, but at a lower cost.',
    ],
  },
  quality: {
    title: 'Quality',
    overview: 'If you pick Quality, you will start with less cash on hand but a higher amount of money spent on product development and a larger amount of money able to take out in loans. Choosing quantity, you will start with plenty of cash but not a very well developed product. Undecided will result in a wishy-washy state where you spend some money on R&D, but not too much.',
    pros: [
      'Your product already includes some of the most in-demand features on the market.',
      'Your product starts off higher demand from the market, due to the reputation and hype that you have created from research and development, as well as marketing efforts.',
      'You may be able to charge a high price for your product.',
    ],
    cons: [
      'After investing so much money into developing your product, you have less money to spend on upgrading your product and creating additional units - you need to turn a profit, and quick. Otherwise, you may be forced into going deeper into debt.',
      'You have spent a lot in developing your product, but some of the features chosen probably were not necessary to achieve high growth. "Nice to haves", not "need to haves".',
      'Placing so much money into developing your product, you have the lowest starting cash available.',
      'You aren’t able to have as many units on hand as you get started.',
    ],
  },
  undecided: {
    title: 'Standard',
    overview: 'This strategy is for companies that want to take practical, pragmatic moves in developing their product. However, standard priced products are difficult to initially market as they do not offer any special features compared to competitors.',
    pros: [
      'You have flexibility to change your product, but a good starting point.',
      'You don’t have the pressure to always have the best product and your customers don’t expect you to.',
      'As you haven’t deeply invested in anything, you have some money to spend as you are starting out.',
    ],
    cons: [
      'The starting consumer demand for your product will be lower, considering your lack of features that competitors provide.',
      'The price you can charge on your product is limited, considering the features and consumer perception of your product. Your margins per sale are smaller.',
      'Your company is seen as mediocre, not a ground breaker.',
      'Your competition has better products, at a higher cost. Some of your competition has inferior products, but at a lower cost.',
    ],
  },
};

export default priceVolumeData;